import { render, staticRenderFns } from "./ImportUsersPage.vue?vue&type=template&id=5964295c"
import script from "./ImportUsersPage.vue?vue&type=script&lang=js"
export * from "./ImportUsersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports